export function isDeepEqual (val1, val2) {
  return JSON.stringify(val1) === JSON.stringify(val2)
}

export function isSameScale (scale1, scale2) {
  let result = isDeepEqual(scale1.domain(), scale2.domain())

  if (!result) {
    return false
  }

  if (scale1.range && scale2.range) {
    result = isDeepEqual(scale1.range(), scale2.range())
  }

  if (!result) {
    return false
  }

  if (scale1.interpolate && scale2.interpolate) {
    result = scale1.interpolate === scale2.interpolate
  }

  return result
}
